module.exports = __webpack_public_path__ + "static/media/nav-icon-okr-active.c3c89054.svg";